import SubscriptionsSection from '@/components/pages/configuration/subscription/SubscriptionsSection';
import Title from '@/components/ui/Title';
import { useTranslation } from 'react-i18next';

export default function BillingPage() {
  const { t } = useTranslation('settings');

  return (
    <div className="space-y-8">
      <Title level={1}>{t('billingPageTitle')}</Title>
      <SubscriptionsSection />
    </div>
  );
}
